import { useEffect } from 'react'
import { track, type AnalyticsEvents } from '../lib/analytics'

// Fire a "view" analytics event once per stable params signature.
//
// Pass `null` while the entity is still loading; the hook will no-op until
// real params arrive. Once params are non-null and equal across renders, the
// event only fires once — onSnapshot updates that produce identical params
// will not re-fire.
//
// Usage:
//   useTrackView('event_viewed', event && { event_id: event.id, event_type: event.type })
export function useTrackView<K extends keyof AnalyticsEvents>(
  eventName: K,
  params: AnalyticsEvents[K] | null | undefined,
) {
  const depKey = params ? JSON.stringify(params) : null
  useEffect(() => {
    if (!params) return
    track(eventName, params)
    // params is captured via the stringified depKey; including it directly would
    // re-fire on every snapshot reference change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventName, depKey])
}
